import { Helpers } from '../../helpers';
import { IBullpen } from '../../interfaces/ibullpen';
import { ScenarioWell } from '../scenario-well';

export class BullpenBase {
  BullpenId: number;
  Name: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_Bullpen?: Array<ScenarioWell> | null;

  constructor(item?: IBullpen) {
    if (item) {

      this.BullpenId = item.BullpenId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_Bullpen = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_Bullpen);
    }
  }
}